import { render, staticRenderFns } from "./AddMember.vue?vue&type=template&id=c6c2a412&"
import script from "./AddMember.vue?vue&type=script&lang=js&"
export * from "./AddMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports